/* eslint-disable react/require-default-props */
import React from 'react';
import clsx from 'clsx';
import { Box } from '@material-ui/core';
import { useStyles } from './styles';

interface HeaderItem {
  component: React.ReactNode;
  className?: string;
  classNameScrolled?: string;
  show?: boolean;
  isPrimaryHeader?: boolean;
}

interface DrawerHeaderProps {
  items: HeaderItem[];
  scrolled?: boolean;
}

export const DrawerHeader = ({ items, scrolled }: DrawerHeaderProps) => {
  const hasExtraBanner = items.some(
    ({ isPrimaryHeader, show }) => !isPrimaryHeader && show,
  );
  const classes = useStyles({ hasExtraBanner });

  return (
    <>
      {items.map(
        ({
          component,
          className,
          classNameScrolled,
          show = true,
          isPrimaryHeader = false,
        }: HeaderItem) => {
          const defaultStyles = isPrimaryHeader
            ? classes.primaryHeader
            : classes.secondaryHeader;

          const defaultStylesScrolled = isPrimaryHeader
            ? classes.primaryHeaderScrolled
            : classes.secondaryHeaderScrolled;

          return (
            <>
              {show && (
                <Box
                  className={clsx(
                    defaultStyles,
                    scrolled && classes.hide,
                    className,
                  )}
                >
                  {component}
                </Box>
              )}

              {scrolled && show && (
                <Box
                  className={clsx(
                    defaultStyles,
                    defaultStylesScrolled,
                    className,
                    classNameScrolled,
                  )}
                >
                  {component}
                </Box>
              )}
            </>
          );
        },
      )}
    </>
  );
};

export default DrawerHeader;
